module.exports = __webpack_public_path__ + "img/poter6.0eefd2ea.jpg";